var removeFalsies = function(obj) {
  return _.transform(obj, function(o, v, k) {
    if (v && typeof v === 'object') {
      o[k] = _.removeFalsies(v);
    } else if (v) {
      o[k] = v;
    }
  });
};

var parseQueryString = function(str) {
  return str.replace(/(^\?)/, '').split('&').map(function(n) {
    return n = n.split('='), this[n[0]] = n[1], this
  }.bind({}))[0];
}

_.mixin({
  removeFalsies: removeFalsies,
  parseQueryString: parseQueryString
});

define("_", ["lodash"], function(){});

